import AddEventForm from './components/AddEventForm';
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import './App.css';

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1366,
      xl: 1920
    }
  },
  palette: {
    primary: {
      main: "#000"
    },
    secondary: {
      main: "#fff"
    }
  },
  typography: {
    fontFamily: 'Poppins'
  }
});

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <AddEventForm />
      </ThemeProvider>
    </div>
  );
}

export default App;
